import { Component, createRef } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Card } from 'primereact/card';
import { Dialog } from 'primereact/dialog';
import BlockUi from '@availity/block-ui';

import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import CargaCatalogo from '../../Components/CargaCatalogo';
import { cadenas } from '../../Utils/cadenas';
import { PATHS_API, NUM_ROWS_POR_PAGINA } from '../../Utils/constants';
import { APIGATEWAY } from '../../Api/ApiGateway';
import { Toast } from 'primereact/toast';
import { saveAs } from 'file-saver';
import { timestampDescarga } from '../../Utils/fechas';

/** Definición del estado para el componente. */
interface State {
  catalogo: Array<{}>;
  dialogVisible: boolean;
  dialogVisibleCarga: boolean;
  cargaVisible: boolean;
  importar: boolean;
  blocking: boolean;
  [key: string]: any;
  tituloDialog: string;
  labelBtnAccion: string;
}
/**
 * @class
 * Componente de tipo clase para mostrar la pantalla donde se realiza
 * la administración del catalogo de tipo DANIO.
 */
class SeveridadDanio extends Component<{}, State> {
  private dataTable: any;
  private toast: any;
  exportToCSV = (data: any[], columnas: string[], encabezados: Record<string, string>, filenamePrefix: string) => {
      if (!data || data.length === 0) return;
      const now = new Date();
      const timestamp = timestampDescarga(); // Ej: 2025-10-02T11-12-00-000Z
      const filename = `${filenamePrefix}_${timestamp}.csv`;

      const headers = columnas.map((col) => encabezados[col] || col);
      const rows = data.map((row) => columnas.map((field) => `"${row[field] ?? ''}"`).join(','));
      const csvContent = [headers.join(','), ...rows].join('\n');
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

      saveAs(blob, filename);
  };
  constructor(props: any) {
    super(props);
    this.dataTable = createRef();

    this.state = {
      catalogo: [],
      parseData: [],
      parseDataError: [],
      dialogVisible: false,
      dialogVisibleCarga: false,
      cargaVisible: true,
      importar: false,
      blocking: false,
      tituloDialog: '',
      labelBtnAccion: '',
      transportistaSeleccionada: { label: '', value: '' },
      transportistas: [],
      nombre: '',
      codigo: '',
      estado: '',
      type: 3,
    };
    this.toast = createRef();
    this.export = this.export.bind(this);
    this.settearState = this.settearState.bind(this);
    this.showDialogCarga = this.showDialogCarga.bind(this);
    this.limpiarFormulario = this.limpiarFormulario.bind(this);
    this.limpiarFormularioCarga = this.limpiarFormularioCarga.bind(this);
    this.obtenerCatalogo = this.obtenerCatalogo.bind(this);
    this.eliminar = this.eliminar.bind(this);
    this.editar = this.editar.bind(this);
    this.abrir = this.abrir.bind(this);
    this.cargar = this.cargar.bind(this);
  }

  /**
   * Se ejecuta antes de renderizar el componente.
   */
  componentDidMount = async () => {
    let res = await APIGATEWAY.validar();
    if (res) {
      this.obtenerCatalogo();
    }
  };
  /**
   * Mostrar el dialog para registrar usuario.
   */
  showDialogCarga() {
    this.limpiarFormularioCarga();
    this.setState({
      inicia: false,
      blocking: false,
      dialogVisibleCarga: true,
      tituloDialog: cadenas.CATALOGO_DIALOG_TITULO,
      labelBtnAccion: cadenas.BTN_GUARDAR,
    });
  }
  /**
   * Obtener los catalogos de tipo danio.
   */
  obtenerCatalogo() {
    let body = {
      codigo: '',
      nombre: '',
      estado: '',
    };
    APIGATEWAY.post(PATHS_API.CATALOGO_DANIOS_SEVERIDAD_QUERY, body)
      .then((response) => {
        if (response !== null && response.length > 0) {
          response.sort((a: any, b: any) => a.codigo - b.codigo);
        }
        this.setState({
          catalogo: response,
          blocking: false,
        });
      })
      .catch((error) => {
        this.setState({ blocking: false });
        this.showNotificacion(cadenas.GROWL_ERROR, cadenas.ERROR_TITULO, cadenas.CATALOGO_ERROR_OBTENER);
      });
  }
  /**
   * Función para acceder al valor de los inputs
   * del componente FormularioRegistro.
   */
  settearState(id: string, value: any) {
    this.setState({ [id]: value, parseDataError: [] });
  }
  /**
   * Mostrar la notificación de tipo Growl (componente del framewrok Prime React).
   * @param {string} type Tipo de la notificación.
   * @param {string} title Título de la notificación.
   * @param {string} message Mensaje de la notificación.
   */
  showNotificacion(type: string, title: string, message: string) {
    this.toast.current?.show({
      severity: type,
      summary: title,
      detail: message,
    });
  }

  /**
   * Exportar los datos del datatable a formato CSV.
   * @param {any} dataTable Referencia del datatable.
   */
  export() {
    if (this.dataTable.current) {
      const data = this.dataTable.current.props.value;
      if (data.every((u: any) => 'codigo' in u)) {
        const columnasExportadas = ['codigo', 'nombre', 'estado'];
        const encabezadosPersonalizados = {
          codigo: cadenas.CATALOGO_CODIGO,
          nombre: cadenas.CATALOGO_NOMBRE,
          estado: cadenas.CATALOGO_ESTADO,
        };
        this.exportToCSV(data, columnasExportadas, encabezadosPersonalizados, 'severidaddanio');
      } else {
        this.dataTable.current.exportCSV();
      }
    }
    this.setState({ cargaVisible: true });
  }
  abrir() {
    this.setState({ importar: true });
  }

  /**
   * Eliminar el registro
   * @param {any} rowData Instancia del row que pertenece al datatable.
   */
  eliminar(rowData: any) {
    this.setState({ blocking: true });
    let body = {
      codigo: rowData.codigo,
      nombre: rowData.nombre,
      estado: rowData.estado,
    };
    APIGATEWAY.post(PATHS_API.CATALOGO_DANIOS_SEVERIDAD_DELETE, body)
      .then(() => {
        this.setState({
          blocking: false,
          dialogVisible: false,
        });
        this.showNotificacion(cadenas.GROWL_SUCCESS, cadenas.EXITO_TITUTLO, cadenas.ACCION_EXITOSA);
        this.obtenerCatalogo();
      })
      .catch((error) => {
        console.log('AdminTransportista -> eliminar -> error', error);
        this.setState({ blocking: false });
        this.showNotificacion(cadenas.GROWL_ERROR, cadenas.ERROR_TITULO, cadenas.ADMINTRANSPORTISTA_ERROR_ELIMINACION);
      });
  }
  /**
   * Cargar catalogo
   */
  cargar() {
    if (this.state.parseDataError.length === 0) {
      if (this.state.parseData.length > 0) {
        this.setState({ blocking: true });
        let body = this.state.parseData;
        console.log('items');
        console.log(body);
        this.setState({ dialogVisibleCarga: false });
        this.limpiarFormularioCarga();
        APIGATEWAY.post(PATHS_API.CATALOGO_DANIOS_SEVERIDAD_CARGA, body)
          .then(() => {
            this.setState({
              blocking: false,
              dialogVisibleCarga: false,
            });
            this.showNotificacion(cadenas.GROWL_SUCCESS, cadenas.EXITO_TITUTLO, cadenas.ACCION_EXITOSA);
            this.obtenerCatalogo();
          })
          .catch((error) => {
            this.setState({ blocking: false });
            this.showNotificacion(cadenas.GROWL_ERROR, cadenas.ERROR_TITULO, cadenas.CATALOGO_ERROR_CARGA);
          });
      } else {
        this.showNotificacion(cadenas.GROWL_ERROR, cadenas.ERROR_TITULO, cadenas.CATALOGO_CARGA_VACIA);
      }
    } else {
      this.showNotificacion(cadenas.GROWL_ERROR, cadenas.ERROR_TITULO, cadenas.CATALOGO_ERROR_CARGA_LISTA);
    }
  }
  /**
   * Editar catalogo.
   * @param {any} rowData Instancia del row que pertenece al datatable.
   */
  editar(rowData: any) {
    if (this.state.nombre.length <= 200) {
      if (!isNaN(parseInt(this.state.estado)) && this.state.estado < 2) {
        this.setState({ blocking: true });
        let body = {
          codigo: this.state.codigo,
          nombre: this.state.nombre,
          estado: this.state.estado,
        };
        APIGATEWAY.post(PATHS_API.CATALOGO_DANIOS_SEVERIDAD_UPDATE, body)
          .then((response) => {
            this.obtenerCatalogo();
            this.showNotificacion(cadenas.GROWL_SUCCESS, cadenas.EXITO_TITUTLO, cadenas.ACCION_EXITOSA);
            this.showNotificacion(cadenas.GROWL_SUCCESS, cadenas.EXITO_TITUTLO, cadenas.CATALOGO_EXITOSO);
          })
          .catch((error) => {
            this.setState({ blocking: false });
            this.showNotificacion(cadenas.GROWL_ERROR, cadenas.ERROR_TITULO, cadenas.ACCION_NO_EXITOSA);
          });
      } else {
        this.showNotificacion(cadenas.GROWL_ERROR, cadenas.ERROR_TITULO, cadenas.CATALOGO_ERROR_ESTADO);
      }
    } else {
      this.showNotificacion(cadenas.GROWL_ERROR, cadenas.ERROR_TITULO, cadenas.CATALOGO_ERROR_NOMBRE);
    }
  }
  /**
   * Limpiar las variables de estado.
   * */
  limpiarFormulario() {
    this.setState({
      codigo: '',
      nombre: '',
      estado: '',
    });
  }
  /**
   * Limpiar las variables de estado.
   * */
  limpiarFormularioCarga() {
    this.setState({
      parseData: [],
      parseDataError: [],
    });
  }

  /**
   * @function
   * Función principal para renderizar el contenido del componente.
   */
  render() {
    const headerDatatable = (
      <div className="p-grid">
        <div className="p-col-12 mb-1" style={{ textAlign: 'right' }}>
          <Button
            disabled={this.state.catalogo.length === 0}
            type="button"
            icon="pi pi-download"
            iconPos="left"
            label={cadenas.BTN_EXPORTAR_CSV}
            onClick={this.export}
          />
        </div>
        <div className="p-col-12" style={{ textAlign: 'right' }}>
          <Button
            disabled={false}
            type="button"
            icon="pi pi-upload"
            iconPos="left"
            label={cadenas.BTN_IMPORTAR_CSV}
            onClick={this.showDialogCarga}
          />
        </div>
      </div>
    );
    const actionDatatable = (rowData: any, column: any) => {
      return (
        <div>
          <Button
            tooltip={cadenas.BTN_EDITAR}
            tooltipOptions={{ position: 'top' }}
            type="button"
            icon="pi pi-pencil"
            className="p-button-success"
            style={{ marginRight: '.5em' }}
            onClick={(e) => {
              this.setState({
                dialogVisible: true,
                nombre: rowData.nombre,
                codigo: rowData.codigo,
                estado: rowData.estado,
              });
            }}
          />
          <Button
            tooltip={cadenas.BTN_ELIMINAR}
            tooltipOptions={{ position: 'top' }}
            type="button"
            icon="pi pi-trash"
            className="p-button-warning"
            onClick={(e) => {
              if (window.confirm(cadenas.CONFIRMAR_ACCION)) {
                this.eliminar(rowData);
              }
            }}
          />
        </div>
      );
    };
    const footerDialog = (
      <div>
        <Button
          className="p-button p-button-success"
          label={cadenas.BTN_EDITAR}
          icon="pi pi-check"
          type="button"
          onClick={(e) => {
            this.limpiarFormulario();
            this.setState({ dialogVisible: false });
            this.editar(e);
          }}
        />
        <Button
          type="button"
          className="p-button p-button-danger"
          label={cadenas.BTN_CANCELAR}
          icon="pi pi-times"
          onClick={(e) => {
            this.limpiarFormulario();
            this.setState({ dialogVisible: false });
          }}
        />
      </div>
    );
    const footerDialogCarga = (
      <div>
        <Button
          className="p-button p-button-success"
          label={cadenas.BTN_GUARDAR}
          id="cargarButton"
          icon="pi pi-check"
          type="button"
          onClick={(e) => {
            this.cargar();
          }}
        />
        <Button
          type="button"
          className="p-button p-button-danger"
          label={cadenas.BTN_CANCELAR}
          icon="pi pi-times"
          onClick={(e) => {
            this.limpiarFormularioCarga();
            this.setState({ dialogVisibleCarga: false });
          }}
        />
      </div>
    );
    return (
      <div>
        <BlockUi message="Cargando.." tag="div" blocking={this.state.blocking}>
          <Toast ref={this.toast} />
          <div className="p-grid">
            <div className="p-col-12">
              <Card style={{ padding: '1em' }}>
                <div className="p-col-12" style={{ textAlign: 'center' }}>
                  <h1>{cadenas.CATALOGO_SEVERIDAD_TITULO}</h1>
                </div>
                <div className="p-grid">
                  <div className="p-col-12">
                    <DataTable
                      filterDisplay="row"
                      value={this.state.catalogo}
                      paginator={true}
                      rows={NUM_ROWS_POR_PAGINA}
                      header={headerDatatable}
                      responsiveLayout="scroll"
                      ref={this.dataTable}
                      emptyMessage={cadenas.DATATABLE_VACIO}
                    >
                      <Column
                        showFilterMenu={false}
                        filterMatchMode="contains"
                        field="codigo"
                        header={cadenas.CATALOGO_CODIGO}
                        filter={true}
                        sortable={true}
                      />
                      <Column
                        showFilterMenu={false}
                        filterMatchMode="contains"
                        field="nombre"
                        header={cadenas.CATALOGO_NOMBRE}
                        filter={true}
                        sortable={true}
                      />
                      <Column
                        showFilterMenu={false}
                        filterMatchMode="contains"
                        body={(rowData: any, column: any) => (rowData.estado === '1' ? 'Activo' : 'Inactivo')}
                        header={cadenas.CATALOGO_ESTADO}
                        filter={true}
                        field="estado"
                        sortable={true}
                      />
                      <Column
                        exportable={false}
                        body={actionDatatable}
                        style={{ textAlign: 'center', width: '10em' }}
                      />
                    </DataTable>
                  </div>
                </div>
              </Card>
            </div>
            <form onSubmit={this.editar}>
              <Dialog
                header={this.state.tituloDialog}
                visible={this.state.dialogVisible}
                position="center"
                blockScroll={true}
                footer={footerDialog}
                style={{ width: '50vw' }}
                modal={true}
                onHide={() => {
                  this.limpiarFormulario();
                  this.setState({ dialogVisible: false });
                }}
              >
                <div className="p-fluid">
                  <div className="col-12" style={{ display: 'inline-flex' }}>
                    <label htmlFor="codigoEmpresa" className="col-3">
                      {cadenas.CATALOGO_CODIGO}: *
                    </label>
                    <div className="col-9">
                      <InputText
                        id="codigo"
                        type="text"
                        disabled={true}
                        required={true}
                        value={this.state.codigo}
                        onChange={(e) => this.setState({ codigo: (e.target as HTMLInputElement).value })}
                      />
                    </div>
                  </div>
                  <div className="col-12" style={{ display: 'inline-flex' }}>
                    <label htmlFor="codigoEmpresa" className="col-3">
                      {cadenas.CATALOGO_NOMBRE}: *
                    </label>
                    <div className="col-9">
                      <InputTextarea
                        rows={5}
                        cols={30}
                        autoResize
                        id="nombre"
                        disabled={false}
                        required={true}
                        maxLength={200}
                        value={this.state.nombre}
                        onChange={(e) => {
                          const value = (e.target as HTMLTextAreaElement).value;
                          this.setState({ nombre: value });
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-12" style={{ display: 'inline-flex' }}>
                    <label htmlFor="codigoEmpresa" className="col-3">
                      {cadenas.CATALOGO_ESTADO}: *
                    </label>
                    <div className="col-9">
                      <InputText
                        id="estado"
                        type="number"
                        disabled={false}
                        required={true}
                        maxLength={1}
                        value={this.state.estado}
                        onChange={(e) => this.setState({ estado: (e.target as HTMLInputElement).value })}
                      />
                    </div>
                  </div>
                </div>
              </Dialog>
            </form>
            <form>
              <Dialog
                header={this.state.tituloDialog}
                visible={this.state.dialogVisibleCarga}
                position="center"
                blockScroll={true}
                footer={footerDialogCarga}
                style={{ width: '50vw' }}
                modal={true}
                onHide={() => {
                  this.limpiarFormularioCarga();
                  this.setState({ dialogVisibleCarga: false });
                }}
                onShow={() => {
                  document.getElementById('cargarButton')?.setAttribute('disabled', 'true');
                }}
              >
                <div className="p-fluid">
                  <div className="p-field p-grid"></div>
                </div>
                <CargaCatalogo settearState={this.settearState} stateParent={this.state} />
              </Dialog>
            </form>
          </div>
        </BlockUi>
      </div>
    );
  }
}

export default SeveridadDanio;
